import { Job } from '@/services/public-jobs.service';

export enum JobBlocksVariant {
  CARD_CAROUSEL = 'CARD_CAROUSEL',
  HIGH_PAYING_JOBS = 'HIGH_PAYING_JOBS',
  LOCATIONS = 'LOCATIONS',
}

export type JobBlocksCardCarouselProps = {
  variant: JobBlocksVariant.CARD_CAROUSEL;
  id: string;
  title: string;
  subtitle: string;
  discipline?: string;
  specialty?: string;
  jobs: Job[];
};

export type JobBlocksHighPayingJobsProps = {
  variant: JobBlocksVariant.HIGH_PAYING_JOBS;
  id: string;
};

export type JobBlocksLocationsProps = {
  variant: JobBlocksVariant.LOCATIONS;
  id: string;
};

export type JobBlocksProps =
  | JobBlocksCardCarouselProps
  | JobBlocksHighPayingJobsProps
  | JobBlocksLocationsProps;
